// extracted by mini-css-extract-plugin
export default {"tableWrap":"ScheduledFulfillmentsCard_tableWrap__q4uko"};